// True when a cell may stay blank instead of being coerced to 0.
// ICell and reverse parsers use allowEmptyValues; Financials rowConfig still sets allowEmptyValue.
const cellAllowsEmpty = (cell?: {
  allowEmptyValue?: boolean | null;
  allowEmptyValues?: boolean | null;
} | null) => Boolean(cell?.allowEmptyValues || cell?.allowEmptyValue);

export default cellAllowsEmpty;
